<template>
    <div class="memberManage">
      <el-row>
            <el-col>
               <div class="query">
                <div>
                    姓名:
                    <el-input
                        style="width: 150px;"
                        placeholder="请输入姓名"
                        clearable
                        size="mini"
                        @keyup.enter.native="findMemberPageList"
                        v-model="queryParam.name"
                        prefix-icon="el-icon-user"
                    ></el-input
                    >&nbsp;手机号码:
                    <el-input
                        style="width: 150px;"
                        placeholder="请输入手机号码"
                        clearable
                        size="mini"
                        @keyup.enter.native="findMemberPageList"
                        v-model="queryParam.phone"
                        prefix-icon="el-icon-mobile-phone"
                    ></el-input>
                    <el-button
                        type="primary"
                        circle
                        plain
                        size="mini"
                        @click="findMemberPageList"
                        icon="el-icon-search"
                    ></el-button>
                </div>
                <div>
                    <el-button type="primary" plain size="mini" @click="addMember"
                        >登记用户</el-button
                    >
                    <el-divider direction="vertical"></el-divider>
                    <el-button
                        type="primary"
                        plain
                        size="mini"
                        @click="addTransRecord"
                        >销售开单</el-button
                    >
                </div>
            </div>
            </el-col>
        </el-row>
        <el-row v-has="'member:select'">
            <el-col>
                <transition name="el-zoom-in-center">
            <el-table
                :data="tableData"
                style="width: 100%"
                highlight-current-row
                @current-change="currentRowChange"
                :hide-on-single-page="singleShow"
                element-loading-text="正在加载数据"
                @row-dblclick="dbclick"
                stripe
                border
                v-show="show"
            >
                <el-table-column
                  prop="name" label="姓名"
                  width="150">
                </el-table-column>
                <el-table-column
                    prop="gender"
                    :formatter="genderFormatter"
                    label="性别"
                    width="80"
                ></el-table-column>
                <el-table-column
                    prop="phone"
                    label="手机号码"
                    width="150"
                ></el-table-column>
                <el-table-column
                    prop="birthTime"
                    label="出生日"
                     width="150"
                ></el-table-column>
                <el-table-column
                    prop="address"
                    label="地址"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="remark"
                    label="备注"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    prop="createTime"
                    label="登记日期"
                     width="220"
                ></el-table-column>
              <el-table-column
                  fixed="right"
                  label="操作"
                  width="100">
                <template slot-scope="scope">
                  <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
        </transition>
                <el-row>
                    <el-col :span="24">
                       <el-pagination
                    class="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="paginations.page_index"
                    :page-sizes="paginations.page_sizes"
                    :page-size="paginations.page_size"
                    :layout="paginations.layout"
                    :total="paginations.total"
                ></el-pagination>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>


        <member-detail
            :dialog="detailDialog"
            @refresh="refresh"
        ></member-detail>
        <add-member :dialog="addDialog" @result="reserve"></add-member>
        <trans-record
            :dialog="transDialog"
            :id="transDialog.transData.id"
            :name="transDialog.transData.name"
            @result="transReserve"
        ></trans-record>
    </div>
</template>

<script>
import { findMemberPageList,delMember } from "@/api/index";
import MemberDetail from "./MemberDetail.vue";
import AddMember from "./AddMember.vue";
import TransRecord from "./TransRecord.vue";

export default {
    components: {
        MemberDetail,
        AddMember,
        TransRecord
    },
    data() {
        return {
            show: false, //初始隐藏  为了打开的动画效果
            singleShow: false,
            queryParam: {
                name: "",
                phone: ""
            },
            detailDialog: {
                show: false,
                clickModal: false,
                pressEscape: true,
                member: {}
            },
            addDialog: {
                show: false,
                clickModal: false,
                pressEscape: true
            },
            transDialog: {
                show: false,
                clickModal: false,
                pressEscape: true,
                transData: {
                    id: null,
                    name: ""
                }
            },
            tableData: [],
            paginations: {
                page_index: 1, //当前位于哪页
                total: 0, //总数
                page_size: 5, //每页显示多少条
                page_sizes: [5, 10, 20], //下拉选择
                layout: "total, sizes, prev, pager, next, jumper"
            }
        };
    },
    methods: {
        handleClick(row) {
          this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            delMember(row.id).then(res => {
              if (res.success == true) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success'
                })
                this.refresh()
              }else{
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: 'error'
                })
              }
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        },
        tableRowClassName({ row, rowIndex }) {
            let index = rowIndex + 1;
            if (index % 2 != 0) {
                return "success-row";
            }
            return "";
        },
        findMemberPageList() {
            let that = this;
            findMemberPageList({
                name: this.queryParam.name,
                phone: this.queryParam.phone,
                pageIndex: this.paginations.page_index,
                size: this.paginations.page_size
            }).then(res => {
                if (res.success == true) {
                    that.tableData = res.result.list;
                    this.paginations.total = res.result.total;
                } else {
                    this.$notify.error({
                        title: "错误",
                        message: res.message
                    });
                }
            });
        },
        handleSizeChange(val) {
            this.paginations.page_size = val;
            this.findMemberPageList();
        },
        handleCurrentChange(val) {
            this.paginations.page_index = val;
            this.findMemberPageList();
        },
        dbclick(row) {
            this.detailDialog.member = JSON.parse(JSON.stringify(row));
            this.detailDialog.show = true;
        },
        addMember() {
            this.addDialog.show = true;
        },
        genderFormatter(row, column) {
            return row.gender == "1" ? "男" : "女";
        },
        reserve() {
            this.addDialog.show = false;
            this.$message({
                showClose: true,
                message: "登记成功",
                type: "success"
            });
            this.refresh();
        },
        refresh() {
            this.findMemberPageList();
        },
        transReserve() {
            this.transDialog.show = false;
            this.$message({
                showClose: true,
                message: "开单成功",
                type: "success"
            });
            this.refresh();
        },
        addTransRecord() {
            if (
                this.transDialog.transData == null ||
                this.transDialog.transData.id == null ||
                this.transDialog.transData.name == null
            ) {
                this.$notify({
                    title: "提示",
                    message: "请单击指定客户进行开单",
                    type: "warning"
                });
            } else {
                this.transDialog.show = true;
            }
        },
        currentRowChange(row) {
            if (row != null) {
                this.transDialog.transData.id = row.id;
                this.transDialog.transData.name = row.name;
            }
        }
    },
    created() {
        this.findMemberPageList();
    },
    mounted() {
        this.show = true;
    }
};
</script>

<style lang="scss">
.memberManage {
    background-color: #ffffff;
    padding: 16px;
    margin: 20px;
    border-radius: 10px;
    -webkit-box-shadow: 0px 3px 3px #c8c8c8;
    -moz-box-shadow: 0px 3px 3px #c8c8c8;
    box-shadow: 0px 3px 3px #c8c8c8;

    .el-table--enable-row-hover .el-table__body tr:hover > td {
        background-color: #ecf5ff;
    }
    .el-table__body tr.current-row > td {
        background: #0089ff !important;
        color: #ffffff;
    }
    .query {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding-bottom: 10px;
    }
    .el-table {
        .success-row {
            background: #f0f9eb;
        }
    }
}
</style>
